import { Avatar, AvatarFallback, AvatarImage } from '@playbooks/ui/components/avatar';
import { Icon } from '@playbooks/ui/components/icon';
import { Tooltip, TooltipContent, TooltipTrigger } from '@playbooks/ui/components/tooltip';

const initials = contact =>
	(contact.name || contact.email || '?')
		.split(/\s+|@/)
		.filter(Boolean)
		.slice(0, 2)
		.map(value => value[0]?.toUpperCase())
		.join('');

const IndexSplashProof = ({ contacts = [] }) => (
	<div className='flex-middle flex-wrap gap-3'>
		{contacts.length > 0 && (
			<div className='flex items-center -space-x-2'>
				{contacts.slice(0, 6).map(contact => {
					const label = contact.name || contact.email || 'Early access member';
					return (
						<Tooltip key={contact.uuid || contact.id || contact.email}>
							<TooltipTrigger render={<span className='relative inline-flex cursor-default' />}>
								<Avatar>
									{contact.thumbnail ? (
										<AvatarImage src={contact.thumbnail} alt={label} className='size-7 ring-2 ring-canvas' />
									) : (
										<AvatarFallback className='size-7 ring-2 ring-canvas'>{initials(contact)}</AvatarFallback>
									)}
								</Avatar>
							</TooltipTrigger>
							<TooltipContent>{label}</TooltipContent>
						</Tooltip>
					);
				})}
			</div>
		)}
		<span className='flex-middle gap-2 text-sm text-foreground-body'>
			<span className='flex-middle size-7 shrink-0 rounded-panel border border-action/20 bg-action/10 text-action'>
				<Icon type='fad' icon='rocket' className='size-3.5' aria-hidden />
			</span>
			<span>Join the builders shaping what comes next.</span>
		</span>
	</div>
);

export { IndexSplashProof };
